import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Styles from './styles'
import * as pageActions from '../store/page'
import Y from '../y18n'
import TopNavigation from './top-navigation'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  pageActions: bindActionCreators(pageActions, dispatch)
})

class TopNavigationAppShell extends Component {
  state = {
    transparent: false
  }

  componentDidMount () {
    this.props.pageName
      ? this.props.pageActions.setPageName(Y`${this.props.pageName}`)
      : this.props.pageActions.setPageName('')
    var body = document.getElementsByTagName('BODY')[0]
    this.props.startPage && body.addEventListener('scroll', this.handleScroll)
    this.props.startPage && this.setState({ transparent: true })
  }

  componentWillUnmount () {
    var body = document.getElementsByTagName('BODY')[0]
    this.props.startPage && body.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = e => {
    var el = document.getElementById('hero')
    var minPixel = el.offsetTop
    var maxPixel = minPixel + el.scrollHeight - 64
    var value = window.pageYOffset || document.body.scrollTop
    var percent = (value - minPixel) / (maxPixel - minPixel)
    percent = Math.min(1, Math.max(percent, 0)) * 100
    if (percent === 100 && this.props.startPage) {
      this.setState({ transparent: false })
    } else if (!this.state.transparent && percent < 100) {
      this.setState({ transparent: true })
    }
  }

  render () {
    const { classes } = this.props
    return (
      <div className={classes.rootContainer}>
        <div className={'container'} style={{ flexDirection: 'column' }}>
          <TopNavigation transparent={this.state.transparent} />
          <div className={'main2'} style={{ marginTop: '0' }}>
            <div className={'mainContent2'}>
              {this.props.content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

TopNavigationAppShell = connect(mapStateToProps, mapDispatchToProps)(TopNavigationAppShell)
export default withStyles(Styles)(TopNavigationAppShell)



// WEBPACK FOOTER //
// ./src/common/top-navigation-app-shell.js